import { AxiosResponse } from 'axios';
import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import API from './Api';

export type ExtractApiResponse = {
  id: number;
  created: string;
  finished: string;
  progress: ExtractStatus;
};

export enum ExtractStatus {
  NOT_STARTED = 'not_started',
  STARTED = 'started',
  COMPLETED = 'completed',
  FAILED = 'failed',
  PARTIAL = 'partial',
}

export class ExtractApi extends API {
  static startGroupDataTransactionsExtract(groupId: number) {
    return API.post(
      replaceByObject(ApiUrls.GroupDataTransactionsExtract, { groupId }),
      {}
    ).then((response: AxiosResponse<ExtractApiResponse>) => {
      return response.data;
    });
  }

  static checkExtract(extractId: number) {
    return API.get(replaceByObject(ApiUrls.Extract, { extractId })).then(
      (response: AxiosResponse<ExtractApiResponse>) => {
        return response.data;
      }
    );
  }

  static checkGroup(groupId: number) {
    return API.get(replaceByObject(ApiUrls.GroupExtract, { groupId })).then(
      (response: AxiosResponse<ExtractApiResponse>) => {
        return response.data;
      }
    );
  }
}
